import {Component, inject} from '@angular/core';
import {NgxMaskPipe} from 'ngx-mask';
import {Store} from '@ngrx/store';
import {TranslatePipe} from '@ngx-translate/core';
import {AsyncPipe} from '@angular/common';
import {AppState} from '../../store/store';
import {selectFooterData} from '../../store/contact/contact.selectors';
import {Constants} from '../../constants/constants';

@Component({
  selector: 'app-footer-contact',
  imports: [NgxMaskPipe, TranslatePipe, AsyncPipe],
  templateUrl: './footer-contact.component.html',
  styleUrl: './footer-contact.component.scss',
})
export class FooterContactComponent {

  private store: Store<AppState> = inject(Store<AppState>);

  public PHONE_MASK = Constants.SWISS_PHONE_MASK;

  readonly contact$ = this.store.select(selectFooterData);

}
